import { combineReducers } from "redux";
import { mapReducer } from "./Map/mapReducer";
import { surveyReducer } from "./Map/surveyReducer";
import { navReducer } from "./Map/navReducer";
import { userReducer } from "./userReducer";

export default combineReducers({
	map: mapReducer,
	survey: surveyReducer,
	nav: navReducer,
	user: userReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js